// process.env.isEdit=true为cms
// process.env.isEdit=false为h5

// cms文件中的Manifest = config.js+index.js
// h5文件中的Manifest = index.js，不包含config.js
export default process.env.isEdit ? require('./cms.js').default : require('./h5.js').default;
